import { useMemo } from 'react'
import { AuditLogEntityTypeEnum, useAuditLogSearchQuery } from 'domains/role-management/api'
import { usePartnerId, useRetailerId } from 'utils/routing/params.hooks'

export const useGetDaysSinceLastUpdated = () => {
  const partnerId = usePartnerId()
  const retailerId = useRetailerId()
  // Calculate the last time a role was updated.
  // The audit logs are sorted by newest date first, so we only need the first one.
  const { data, error, loading } = useAuditLogSearchQuery({
    variables: {
      entityType: AuditLogEntityTypeEnum.Role,
      partnerId,
      retailerId,
      first: 1,
    },
    fetchPolicy: 'cache-and-network',
  })

  const days = useMemo(() => {
    // If there are no audit logs, return undefined to show no history message
    if (!data || data.auditLogSearch.edges.length === 0) {
      return undefined
    }

    // Audit logs are sorted by newest date first, so take the first audit log as last updated date
    const minDate = new Date(data?.auditLogSearch.edges[0].node.eventTime)

    // Find the difference between the current date and the last updated date and return the number of days
    return numberOfDaysSince(minDate)
  }, [data])

  return { daysSinceLastUpdated: days, loading, error }
}

export const numberOfDaysSince = (date: Date) =>
  Math.floor(Math.abs((new Date().getTime() - date.getTime()) / (1000 * 60 * 60 * 24)))
